import { Create } from "react-admin";
import { useNotification } from "../../../common/hooks/useNotification";
import { EditActions } from "../../common/form/FormActions";
import { TrailerGpsProviderForm } from "./TrailerGpsProviderForm";

interface Props {}

export const TrailerGpsProviderCreate = (props: Props) => {
  const notify = useNotification(props, "createSuccess");
  return (
    <Create
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      title="resources.admin-trailer-gps-providers.title.create"
    >
      <TrailerGpsProviderForm />
    </Create>
  );
};
